var map = {
	"./add-to-google-drive.svg": "156f",
	"./admin.svg": "2629",
	"./arrow-back.svg": "150a",
	"./arrow-down.svg": "a020",
	"./audio.svg": "9472",
	"./bell.svg": "b4ce",
	"./bug-report.svg": "496e",
	"./bug.svg": "aaa7",
	"./calendar.svg": "05e4",
	"./canva.svg": "db6e",
	"./cart.svg": "28a6",
	"./change-circle.svg": "a258",
	"./check.svg": "91c1b",
	"./chevron-down.svg": "2593",
	"./chevron-left.svg": "b7a2",
	"./chevron-right.svg": "410c",
	"./chevron-up.svg": "a4f0",
	"./clipboard-check-fill.svg": "3fd8",
	"./clipboard-copy.svg": "4ff5",
	"./clock.svg": "b109",
	"./close.svg": "81b5",
	"./cog.svg": "bdab",
	"./color.svg": "5ec6",
	"./colorize.svg": "4a8a",
	"./comment-add.svg": "6fa2",
	"./comment-empty.svg": "5c32",
	"./comment-tooltip.svg": "65d7",
	"./comment.svg": "f370",
	"./company.svg": "e5a3",
	"./copy.svg": "b50c",
	"./delete-permanently.svg": "e80a",
	"./design.svg": "2258",
	"./document-add.svg": "6292",
	"./document.svg": "f1c0",
	"./done-all.svg": "4ed1",
	"./dots-horizontal.svg": "86c6",
	"./dots.svg": "0907",
	"./download-zip.svg": "afa5",
	"./download.svg": "f3e1",
	"./email.svg": "119d",
	"./embed.svg": "d942",
	"./error.svg": "a9b7",
	"./export.svg": "3b03",
	"./external.svg": "0feb",
	"./eye-closed.svg": "dae8",
	"./eye-opened.svg": "bd30",
	"./file.svg": "7a61",
	"./flag.svg": "11ab",
	"./folder-add.svg": "edc88",
	"./folder-filled.svg": "1b31",
	"./folder-opened.svg": "a26ac",
	"./folder.svg": "ab95",
	"./fullscreen.svg": "d4187",
	"./gallery.svg": "5c66",
	"./grid.svg": "7b8b",
	"./hamburger.svg": "564f",
	"./heading-second-second.svg": "d9db",
	"./heading-second.svg": "7930",
	"./heading.svg": "041e",
	"./home.svg": "72d9",
	"./image.svg": "5a3b",
	"./info.svg": "4201",
	"./input-error.svg": "62cc",
	"./invited.svg": "92ae",
	"./link.svg": "c7392",
	"./list.svg": "b9115",
	"./loader.svg": "2d600",
	"./loading.svg": "7a8e",
	"./lock.svg": "4ca6",
	"./logout.svg": "66a1",
	"./minus.svg": "b294f",
	"./move.svg": "9065",
	"./network-intelligence-history.svg": "8435",
	"./next.svg": "464b",
	"./nextsimple.svg": "31ff",
	"./one-drive.svg": "0791",
	"./page.svg": "b46e",
	"./partner.svg": "244b",
	"./pause.svg": "82592",
	"./pen.svg": "3921",
	"./phone.svg": "ea5d",
	"./play.svg": "2787",
	"./plus.svg": "54b9",
	"./prev.svg": "0c513",
	"./preview.svg": "0a0e",
	"./prevsimple.svg": "327f",
	"./question-simple.svg": "ffe1",
	"./question.svg": "c30e",
	"./receipts.svg": "5953",
	"./rectangle.svg": "a9ee",
	"./reload.svg": "4127",
	"./resize-down.svg": "8f3b",
	"./safety-check.svg": "3cfb",
	"./save-floppy-disc.svg": "66e1",
	"./save.svg": "e166",
	"./search.svg": "58af",
	"./share-list.svg": "c171",
	"./share.svg": "804e",
	"./simplecheck.svg": "b90a",
	"./sort-19.svg": "2e84",
	"./sort-az.svg": "6f7e",
	"./sort-down.svg": "a5a6",
	"./sort-up-down.svg": "f54e",
	"./sort-up.svg": "163e0",
	"./star.svg": "f591",
	"./stats.svg": "b642",
	"./stock-move.svg": "d1a1",
	"./stock-state.svg": "ce26",
	"./stop.svg": "c5ee",
	"./storage.svg": "637a",
	"./supercheck.svg": "c088",
	"./superquestion.svg": "675b",
	"./switch.svg": "72d3",
	"./table-col-2.svg": "f5e4",
	"./table-col.svg": "bcd2",
	"./table-row-2.svg": "819c",
	"./table-row.svg": "45a6",
	"./table.svg": "ff20",
	"./tags.svg": "a926",
	"./team.svg": "5618",
	"./team2.svg": "c91d",
	"./text-fields.svg": "d96d",
	"./text.svg": "4cfb",
	"./tick.svg": "db31",
	"./trash-slim.svg": "9071",
	"./trash.svg": "b2256",
	"./upload.svg": "ea4e",
	"./user-add.svg": "0843",
	"./user.svg": "d7ee9",
	"./verified-user.svg": "6902d",
	"./volume-0.svg": "5e0e",
	"./volume-1.svg": "3a72",
	"./volume-2.svg": "2cda",
	"./warehouse.svg": "d0aa",
	"./wysiwyg.svg": "5b88",
	"./zoomin.svg": "3a84",
	"./zoomout.svg": "019c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2cc9";